import Vue from 'vue';
import { commonVueOptions } from '@/angular-bridge/module';
/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.components')
        .service('VrmModalService', VrmModalService);

    /* @ngInject */
    function VrmModalService(ModalService) {
        var nextCallback = null;

        return {
            'closeActiveModal': closeActiveModal,
            'openLanguageModal': openLanguageModal,
            'openDownloadModal': openDownloadModal,
            'openShareModal': openShareModal,
            'openCarouselModal': openCarouselModal,
            'openUploadModal': openUploadModal,
            'openRemoteConsoleModal': openRemoteConsoleModal,
            'openDeleteModal': openDeleteModal,
            'openConfirmModal': openConfirmModal,
            'openConfirmFieldModal': openConfirmFieldModal,
            'openPasswordConfirmModal': openPasswordConfirmModal,
            'openReportTemplateModal': openReportTemplateModal,
            'openRecurringReportModal': openRecurringReportModal,
            'openUpdateDeviceModal': openUpdateDeviceModal,
            'openWarningModal': openWarningModal,
            'openDownloadConfigurationModal': openDownloadConfigurationModal,
            'openConfiguringModal': openConfiguringModal,
            'openDownloadProductionReportModal': openDownloadProductionReportModal,
            'openAccessTokenModal': openAccessTokenModal,
            'openSuccessModal': openSuccessModal,
            'openErrorModal': openErrorModal,
            'openClearAlarmModal': openClearAlarmModal,
            'openVueModal': openVueModal,
            'open2FAMandatoryModal': open2FAMandatoryModal,
            'openAttributeSearchModal': openAttributeSearchModal,
            'next': next
        };

        /**
         * Call function when modal is closed
         * @param callback
         */
        function next(callback) {
            nextCallback = callback;
        }

        /**
         * Workaround:
         * The removeDelay causes new dialogs to be closed after .close() has been called.
         * This function closes modals instantly by making the library think that animations are not supported.
         * This is undone after finishing the close logic so manual closing of a modal still has the regular behaviour.
         */
        function closeActiveModal() {
            const useTransitions = $.magnificPopup.instance.supportsTransition;
            $.magnificPopup.instance.supportsTransition = false;
            $.magnificPopup.close();
            $.magnificPopup.instance.supportsTransition = useTransitions;
        }

        function openModal(options) {
            options.enableClose = typeof options.enableClose != "undefined" ? options.enableClose : true;
            options.removalDelay = typeof options.removalDelay != "undefined" ? options.removalDelay : 500;
            options.enableEscapeKey = typeof options.enableEscapeKey != "undefined" ? options.enableEscapeKey : false;
            options.showCloseBtn = typeof options.showCloseBtn != "undefined" ? options.showCloseBtn : true;
            options.alignTop = typeof options.alignTop != "undefined" ? options.alignTop : false;
            ModalService.showModal({
                template: options.template,
                controller: options.controller,
                scope: options.scope,
                inputs: options.inputs
            }).then(function (modal) {
                closeActiveModal();
                $.magnificPopup.open({
                    items: {
                        src: modal.element,
                        type: 'inline'
                    },
                    removalDelay: options.removalDelay, //delay removal by X to allow out-animation
                    mainClass: typeof options.customClass != "undefined" ? options.customClass : 'mfp-zoom-in2',
                    enableEscapeKey: options.enableEscapeKey,
                    closeMarkup: options.hideCloseMarkup ? '' : '<span class="vrm-modal__close-handle sg-vrm-icon_060_cross-round-24px mfp-close"></span>',
                    showCloseBtn: options.enableClose && options.showCloseBtn,
                    closeOnBgClick: options.enableClose,
                    alignTop: options.alignTop,
                    fixedContentPos: true, // Keeps modal in viewport
                    callbacks: {
                        open: modal.controller.open,
                        close: function () {
                            modal.controller.close();
                            if (nextCallback != null) {
                                var callback = nextCallback;
                                nextCallback = null;
                                callback(options.scope);
                            }
                        }
                    }
                });
            });
        }

        function openLanguageModal(scope) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/lang/lang-selector.template.html'),
                controller: "LangSelectorController",
                scope: scope
            });
        }

        function openReportTemplateModal(scope, callback) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/reporting/report-template.template.html'),
                controller: "ReportTemplateController",
                scope: scope,
                inputs: {
                    callback: callback
                }
            });
        }

        function openRecurringReportModal(scope, recurringReport, reportTemplates, callback) {
            openModal({
                template: require("@/angular/modules/vrm-components/modal/recurring-report/recurring-report.template.html"),
                controller: "RecurringReportModalController",
                scope: scope,
                inputs: {
                    recurringReport: recurringReport,
                    reportTemplates: reportTemplates,
                    callback: callback
                }
            });
        }

        // message: a locale key in string format, eg.: 'advanced.preparing_download'
        function openDownloadModal(scope, message, close, data = null) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/download/download.template.html'),
                controller: "DownloadModalController",
                scope: scope,
                enableClose: close === true,
                inputs: {
                    message: message,
                    data: data,
                }
            });
        }


        function openShareModal(scope, installation) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/share/share.template.html'),
                controller: "ShareController",
                scope: scope,
                inputs: {
                    installation: installation
                }
            });
        }

        function openRemoteConsoleModal(scope, installation, {onClose = null, onOpened = null}) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/remote-console/remote-console.template.html'),
                controller: "RemoteConsoleController",
                scope: scope,
                inputs: {
                    installation: installation,
                    onClose: onClose,
                    onOpened: onOpened,
                }
            });
        }

        function openCarouselModal(scope, installation) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/carousel/carousel.template.html'),
                controller: "CarouselController",
                scope: scope,
                inputs: {
                    installation: installation
                }
            });
        }

        function openDeleteModal(scope, type, object, callback) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/delete/delete-modal.template.html'),
                controller: "DeleteController",
                scope: scope,
                inputs: {
                    type: type,
                    object: object,
                    callback: callback
                }
            });
        }

        function openConfirmModal(scope, action, callback, { icon, extraText, noBtnClass, yesBtnClass, yesTranslation, noTranslation } = {}, extraClass = null) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/confirm/confirm-modal.template.html'),
                controller: "ConfirmController",
                scope: scope,
                inputs: {
                    action: action,
                    callback: callback,
                    icon: icon ? icon : "sg-vrm-icon_055_cross-16px",
                    extraText: extraText,
                    noBtnClass: noBtnClass || "sg-blue",
                    yesBtnClass: yesBtnClass || "sg-orange",
                    yesTranslation: yesTranslation || "common.yes",
                    noTranslation: noTranslation || "common.no",
                    extraClass: extraClass || ''
                }
            });
        }


        /**
         * @param {object} scope - pass current scope
         * @param {string} action - action name
         * @param {{ expectedFieldValue?: string, checkboxVersion?: boolean}} options - if checkboxVersion is true,
         * then the action will be executed only
         * if the checkbox is checked, otherwise an input field with expected value to be matched is used
         * @param {function} callback - callback function
         * @param {string} title
         * @param {string} description
         * @param {string} extraClass
         */
        function openConfirmFieldModal(scope, action, options, callback, title = null, description = null, extraClass = null) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/confirm-field/confirm-field-modal.template.html'),
                controller: "ConfirmFieldController",
                scope: scope,
                inputs: {
                    action,
                    options,
                    callback,
                    title: title || 'common.' + action + '_confirm_title',
                    description: description || 'common.' + action + '_confirm_message',
                    extraClass: extraClass || ''
                }
            });
        }

        function openPasswordConfirmModal(scope, callback) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/confirm-password/confirm-password-modal.template.html'),
                controller: "ConfirmPasswordController",
                scope: scope,
                inputs: {
                    callback,
                }
            });
        }

        function openUploadModal(scope, type, callback, extraData) {
            if (typeof extraData === "undefined")
                extraData = {};
            openModal({
                template: require('@/angular/modules/vrm-components/modal/upload/upload-modal.template.html'),
                controller: "UploadController",
                scope: scope,
                removalDelay: 0,
                inputs: {
                    type: type,
                    callback: callback,
                    extraData: extraData
                }
            });
        }

        function openUpdateDeviceModal(scope) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/update-device/update-device-modal.template.html'),
                controller: "UpdateDeviceController",
                scope: scope,
                enableClose: false,
                removalDelay: 0
            });
        }

        function openWarningModal(scope, callback, action, description) {
            // displays a modal with a warning description, action button and cancel button.
            // example: firmware update warning when you want to update a device that is in boot mode.
            openModal({
                template: require('@/angular/modules/vrm-components/modal/warning/warning-modal.template.html'),
                controller: "WarningController",
                scope: scope,
                inputs: {
                    callback: callback,         // callback for when the user presses the action button
                    action: action,             // complete data-i18n key for the action button
                    description: description    // complete data-i18n key for the description
                }
            });
        }

        function openDownloadConfigurationModal(scope) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/download-configuration/download-configuration.template.html'),
                controller: "DownloadConfigurationModalController",
                scope: scope,
                enableClose: false,
                removalDelay: 0
            });
        }

        function openConfiguringModal(scope) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/configuring/configuring.template.html'),
                controller: "ConfiguringModalController",
                scope: scope,
                enableClose: false,
                removalDelay: 0
            });
        }

        function openDownloadProductionReportModal(scope, allSiteIds, filteredSiteIds) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/download-production-report/download-production-report.template.html'),
                controller: "DownloadPrductionReportModalController",
                scope: scope,
                inputs: {
                    allSiteIds,
                    filteredSiteIds
                }
            });
        }

        function openAccessTokenModal(scope, token) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/access-tokens/access-tokens-modal.template.html'),
                controller: "AccessTokensModalController",
                scope: scope,
                enableClose: true,
                inputs: {
                    token: token
                }
            });
        }

        function openSuccessModal(scope, message) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/common-modals/success.template.html'),
                controller: "SuccessModalController",
                scope: scope,
                enableClose: true,
                inputs: {
                    message: message
                }
            });
        }

        function openErrorModal(scope, message, errorMessage, errorCode, callback) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/common-modals/error.template.html'),
                controller: "ErrorModalController",
                scope: scope,
                enableClose: true,
                removalDelay: 0,
                inputs: {
                    message,
                    errorMessage,
                    errorCode,
                    callback,
                }
            });
        }

        function openClearAlarmModal(scope, target, callback) {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/clear-alarm/clear-alarm.template.html'),
                controller: "ClearAlarmModalController",
                scope: scope,
                enableClose: true,
                showCloseBtn: true,
                enableEscapeKey: true,
                alignTop: true,
                removalDelay: 0,
                customClass: 'mfo-bg--dialog',
                inputs: {
                    target,
                    callback
                }
            });
        }

        function openVueModal(component, userdata = {},extraOptions= {}) {
            return new Promise(resolve => {
                let closing = false;
                const doClose = (eventData) => {
                    // doClose can be called twice when the vue component closes itself through $emit('close')
                    // This is because magnificPopup.close() leads to the controller's close function to also be called
                    if (!closing) {
                        closing = true;
                        try {
                            $.magnificPopup.close();
                        } finally {
                            resolve(eventData);
                        }
                    }
                };
                ModalService.showModal({
                    template: `<div />`,
                    controller: /* @ngInject */ function($scope, close) {
                        $scope.close = () => {
                            doClose();
                        }
                        /* named funciton important, otherwise controller argument 'close' gets renamed to '_close' leading to ng-injection failure */
                        function handleClose() {
                            try {
                                doClose();
                            } finally {
                                close();
                            }
                        }
                        return { close: handleClose };
                    },
                    scope: null,
                    inputs: {}
                }).then(function(modal) {
                    closeActiveModal();
                    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Calculate the scrollbar width
                    const props = Vue.observable(userdata);
                    const vue = new Vue({
                        ...commonVueOptions,
                        render: h => h(component, {
                            props,
                            // FIX: Each invoke of render() should produce a fresh vnode because vue can end up removing the event listeners
                            on: {
                                close: eventData => {
                                    doClose(eventData)
                                },
                            },
                        }),
                        // FIX: clicking background is detected by DOM-tree check on the presented content
                        // These hooks keeps it in sync
                        mounted() {
                            $.magnificPopup.instance.content[0] = this.$el;
                        },
                        updated() {
                            $.magnificPopup.instance.content[0] = this.$el;
                        },
                    });
                    const options = {
                        items: {
                            src: document.createElement('div'),
                            type: 'inline'
                        },
                        removalDelay: 500, //delay removal by X to allow out-animation
                        mainClass: 'mfp-zoom-in',
                        enableEscapeKey: false,
                        closeMarkup: '',
                        showCloseBtn: false,
                        closeOnBgClick: true,
                        fixedContentPos: true, // Keeps modal in viewport
                        callbacks: {
                            open: function() {
                                document.documentElement.style.marginRight = `${scrollbarWidth}px`;
                                document.body.style.overflow === 'auto' ? document.body.style.overflow = '' : null; // Fix body overflow bug when opening modal (when body overflow auto page scrolls to top)
                                // Mount on the presented div (items.src)
                                vue.$mount(this.content[0]);
                            },
                            close: function() {
                                document.documentElement.style.marginRight = '';
                                modal.controller.close();
                                if (nextCallback != null) {
                                    var callback = nextCallback;
                                    nextCallback = null;
                                    callback(null);
                                    document.body.style.overflow = 'auto';
                                }
                            }
                        }
                    }
                    $.magnificPopup.open(Object.assign(options, extraOptions));
                });
            });
        }

        function open2FAMandatoryModal() {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/2fa-alerts/2fa-mandatory.template.html'),
                controller: '2FAAlertModalController',
                scope: null,
                enableClose: true,
                removalDelay: 0,
            });
        }

        function openAttributeSearchModal() {
            openModal({
                template: require('@/angular/modules/vrm-components/modal/attribute-search/attribute-search.template.html'),
                controller: 'AttributeSearchController',
                scope: null,
                enableClose: true,
                removalDelay: 0
            });
        }
    }
})();
